class Data {
    static instance;
    static students = ["张丽芳", "王朋康", "崔心香", "李听荷", "张玲然", "林宛菡", "吴书意", "赵歌飞", "周冬灵", "张静"];

    constructor(classList, chapterList) {
        this.classList = classList;
        this.chapterList = chapterList;
        this.students = ["张丽芳", "王朋康", "崔心香", "李听荷", "张玲然", "林宛菡", "吴书意", "赵歌飞", "周冬灵", "张静"]; // 学生名字列表
        this.skillList = [
            "视频分析基础",
            "视频内容识别",
            "PS基础操作",
            "设计作品展示",
            "海报设计",
            "视频算法优化",
            "视频数据集制作",
            "视频分析应用实践",
            "视频帧数据处理",
            "视频分析算法评估",
            "视频情感分析",
            "视频搜索引擎",
            "视频分析数据可视化",
            "视频分类与聚类",
            "视频行为识别",
        ];
        this.knowList = ["期中考试", "期末考试", "综合考试", "专项考试", "专项测验", "实操考试"];
        this.classMap = new Map();

        this.initData();
    }

    initData() {
        const studentChapterList = [];
        this.students.forEach((student) => {
            this.chapterList.forEach((chapter) => {
                studentChapterList.push(`${student}_${chapter}`);
            });
        });

        // 格式化classMap，根据班级列表
        this.classList.forEach((item) => {
            // 随机2-4个学生
            const shuffileStudents = this.shuffleArray(this.students);

            const attitudeAssessment = this.generateAttitudeAssessmentData(shuffileStudents.slice(0, this.getRandomInt(2, 4)));
            const skillAssesssment = this.generateSkillAssessmentData(studentChapterList);
            const knowAssessment = this.generateKnowAssessmentData(studentChapterList);

            this.classMap.set(item, {
                attitudeAssessment,
                skillAssesssment,
                knowAssessment,
            });
        });
    }

    // 随机生成作业状态（已结束 / 进行中）
    getRandomHomeworkStatus() {
        return Math.random() > 0.5 ? "已结束" : "进行中";
    }

    // 随机生成提交状态（已提交 / 未提交）
    getRandomSubmissionStatus() {
        return Math.random() > 0.5 ? "已提交" : "未提交";
    }

    // 随机生成数字
    getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    // 随机生成分数，保证分数在合理范围内
    getRandomScore(min, max) {
        return this.getRandomInt(min, max);
    }

    // 打乱数组
    shuffleArray(arr) {
        // 创建一个副本，以避免修改原数组
        const shuffledArray = [...arr];

        // 使用 Fisher-Yates 算法打乱数组
        for (let i = shuffledArray.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(Math.random() * (i + 1)); // 生成随机索引
            // 交换当前元素与随机元素
            [shuffledArray[i], shuffledArray[randomIndex]] = [shuffledArray[randomIndex], shuffledArray[i]];
        }

        return shuffledArray;
    }

    // 生成单项态度考核数据
    generateAttitudeAssessmentItem(studentName) {
        return {
            studentName: studentName,
            attendance: this.getRandomScore(20, 100),
            participation: this.getRandomScore(20, 100),
            homeworkCompletion: this.getRandomScore(20, 100),
            cooperation: this.getRandomScore(20, 100),
            attitude: this.getRandomScore(20, 100),
            classroomPerformance: this.getRandomScore(20, 100),
            problemSolving: this.getRandomScore(20, 100),
            communication: this.getRandomScore(20, 100),
            selfDrive: this.getRandomScore(20, 100),
        };
    }

    // 生成单项技能考核数据
    generateSkillAssessmentItem(skillName) {
        return {
            homeworkName: skillName,
            homeworkStatus: this.getRandomHomeworkStatus(),
            submissionStatus: this.getRandomSubmissionStatus(),
            literacyScore: this.getRandomScore(60, 100),
            individualScore: this.getRandomScore(60, 100),
            classHighestScore: this.getRandomScore(70, 100),
            classLowestScore: this.getRandomScore(50, 70),
            averageScore: this.getRandomScore(60, 90),
        };
    }

    // 生成单项知识考核数据
    generateKnowAssessmentItem(knowName) {
        return {
            homeworkName: knowName,
            homeworkStatus: this.getRandomHomeworkStatus(),
            submissionStatus: this.getRandomSubmissionStatus(),
            individualScore: this.getRandomScore(60, 100),
            classHighestScore: this.getRandomScore(70, 100),
            classLowestScore: this.getRandomScore(50, 70),
            averageScore: this.getRandomScore(60, 90),
        };
    }

    // 随机生成态度考核数据
    generateAttitudeAssessmentData(students) {
        const attitudeAssessmentMap = new Map();

        this.chapterList.forEach((item) => {
            const attitudeAssessmentData = [];

            students.forEach((student) => {
                attitudeAssessmentData.push(this.generateAttitudeAssessmentItem(student));
            });

            // 保存map
            attitudeAssessmentMap.set(item, attitudeAssessmentData);
        });

        return attitudeAssessmentMap;
    }

    // 随机生成技能考核数据
    generateSkillAssessmentData(keys) {
        const skillAssessmentMap = new Map();

        keys.forEach((item) => {
            // 随机生成10-15条数据
            const randomNum = Math.floor(Math.random() * 5) + 10;
            const skillAssessmentData = [];
            for (let i = 0; i < randomNum; i++) {
                const skillName = this.skillList[Math.floor(Math.random() * this.skillList.length)];
                skillAssessmentData.push(this.generateSkillAssessmentItem(skillName));
            }

            // 保存map
            skillAssessmentMap.set(item, skillAssessmentData);
        });

        return skillAssessmentMap;
    }

    // 随机生成知识考核数据
    generateKnowAssessmentData(keys) {
        const knowAssessmentMap = new Map();

        keys.forEach((item) => {
            // 随机生成10-15条数据
            const randomNum = Math.floor(Math.random() * 5) + 10;
            const knowAssessmentData = [];
            for (let i = 0; i < randomNum; i++) {
                const knowName = this.knowList[Math.floor(Math.random() * this.knowList.length)];
                knowAssessmentData.push(this.generateKnowAssessmentItem(knowName));
            }

            // 保存map
            knowAssessmentMap.set(item, knowAssessmentData);
        });

        return knowAssessmentMap;
    }
}

export default Data;
